const activityFilterGroupings = {
  adduser: ['addusers'],
  updateuserdetails: ['addorupdateuserattributes', 'updateuser'],
  updateusersettings: [
    'updateallusersg2arssettings',
    'updateallusersg2mfreesettings',
    'updateallusersg2msettings',
    'updateallusersg2tsettings',
    'updateallusersg2wsettings',
    'updateallusersopenvoicesettings',
    'updategroupusersg2arssettings',
    'updategroupusersg2mfreesettings',
    'updategroupusersg2msettings',
    'updategroupusersg2tsettings',
    'updategroupusersg2wsettings',
    'updategroupusersopenvoicesettings',
    'updatelicenseusersg2arssettings',
    'updatelicenseusersg2mfreesettings',
    'updatelicenseusersg2msettings',
    'updatelicenseusersg2tsettings',
    'updatelicenseusersg2wsettings',
    'updatelicenseusersopenvoicesettings',
    'updateuseropenvoicesettings',
    'updateusersg2arssettings',
    'updateusersg2mfreesettings',
    'updateusersg2msettings',
    'updateusersg2tsettings',
    'updateusersg2wsettings',
    'updateuserg2arssettings',
    'updateuserg2mfreesettings',
    'updateuserg2msettings',
    'updateuserg2tsettings',
    'updateuserg2wsettings',
  ],
  updateusersettings_sw: [
    'updateallusersg2',
    'updateallusersopen',
    'updategroupusersg2',
    'updategroupusersopen',
    'updatelicenseusersg2',
    'updatelicenseusersopen',
    'updateuseropen',
    'updateusersg2',
  ],
  updateproducts: [
    'licenseallusers',
    'licensegroupusers',
    'licenselicenseusers',
    'licenseusers',
    'setalluserslicenses',
    'setgroupuserslicenses',
    'setlicenseuserslicenses',
    'setuserlicenses',
  ],
  deleteuser: ['deleteuser'],
  removeproducts: [
    'removealluserlicenses',
    'unlicenseallusers',
    'unlicensegroupusers',
    'unlicenselicenseusers',
    'unlicenseusers',
  ],
  updatesettings: [
    'addattribute',
    'deleteattribute',
    'updateaccount',
    'updateaccountg2arssettings',
    'updateaccountg2msettings',
    'updateaccountg2tsettings',
    'updateaccountg2wsettings',
    'updateattribute',
    'updatedefaultprofileg2msettings',
    'updatedefaultprofileopenvoicesettings',
    'updateg2monlinetranscriptsterms',
  ],
  groupusers: [
    'groupallusers',
    'groupgroupusers',
    'grouplicenseusers',
    'groupusers',
    'ungroupallusers',
    'ungroupgroupusers',
    'ungrouplicenseusers',
    'ungroupusers',
    'ungroupusers',
  ],

  report: [
    'activityhistoryreport',
    'activityreport',
    'allusersaudiousagereport',
    'allusersactivityreport',
    'allusersconferenceidsreport',
    'allusersintegratedaudiousagereport',
    'allusersmeetingattendeereport',
    'allusersmeetinghistoryreport',
    'allusersregistrantreport',
    'allusersreport',
    'allusersscheduledmeetingreport',
    'alluserswebinarrecordingregistrantreport',
    'audiousagereport',
    'billinghistoryreport',
    'billingratereport',
    'meetingattendeereport',
    'meetinghistoryreport',
    'registrantreport',
    'scheduledmeetingreport',
    'usersaudiousagereport',
    'usersintegratedaudiousagereport',
    'usersreport',
  ],
}

interface getActivityGroupedKeyProps {
  jobType?: string
}

export const getActivityGroupedKey = ({ jobType }: getActivityGroupedKeyProps): string => {
  let groupName

  const matchingGroupIndex = Object.entries(activityFilterGroupings)
    .map((item) => item[1].findIndex((myItem) => myItem === jobType))
    .findIndex((item) => item !== -1)

  if (matchingGroupIndex !== -1) {
    groupName = Object.keys(activityFilterGroupings)[matchingGroupIndex]
  }

  return groupName || jobType
}
